import React from 'react';

export function ClickUpIcon(): React.JSX.Element {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="24" height="24" rx="6" fill="white" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.48145 15.6486L7.88428 13.6389C9.16896 15.4425 10.525 16.2927 12.0238 16.2927C13.5226 16.2927 14.8549 15.4682 16.0682 13.6647L18.5186 15.6228C16.7581 18.1993 14.5694 19.5649 12.0238 19.5649C9.50203 19.5649 7.28952 18.1993 5.48145 15.6486Z"
				fill="#6686FB"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 7.58303L7.53864 11.2685L5.48145 8.9621L12.0248 3.5647L18.5186 8.9621L16.4366 11.2447L12 7.58303Z"
				fill="#FF6479"
			/>
		</svg>
	);
}
